// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__15apD","alert":"SettungsInbox_alert__29soz"};